import { Controller } from 'stimulus';
import axios from 'axios';
import dataLayer from '../helpers/dataLayer';

class NewsletterController extends Controller {
  onFormSubmit(e) {
    e.preventDefault();

    this.validateForm()
      .then((resolve) => this.submitForm(resolve.formData))
      .catch((reject) => this.outputMessage(reject));
  }

  submitForm(data) {
    axios
      .post(this.formTarget.action, data)
      .then((res) => {
        dataLayer.event('Newsletter', 'submit');

        this.showForm(false);
        this.outputMessage(res.data);
      })
      .catch((error) => {
        this.showForm(true);
        this.outputMessage(error.response.data);
      });
  }

  showForm(state) {
    this.formTarget.style.display = state ? 'block' : 'none';
  }

  outputMessage(res) {
    if (typeof res.message === 'undefined') return;

    this.messageTarget.innerText = res.message;
  }

  validateForm() {
    return new Promise((resolve, reject) => {
      if (this.inputTarget.value === '' || this.inputTarget.value.indexOf('@') < 0) {
        return reject(new Error(window.app.i18n.invalidEmailAddress));
      }

      return resolve({
        valid: true,
        formData: new FormData(this.formTarget),
      });
    });
  }
}

NewsletterController.targets = [
  'form',
  'input',
  'message',
];

export default NewsletterController;
